import {
  Container,
  Box,
  Button,
  AppBar,
  Toolbar,
  Typography,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import logo from "../assets/logo.png";

export function LandingPage() {
  return (
    <>
      <AppBar position="static">
        <Toolbar
          sx={{
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
          }}
        >
          <Button variant="contained" component={RouterLink} to="/log-in">
            Log In
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            alt="SeedLeaf logo"
            src={logo}
            sx={{ width: "100%", maxWidth: 480 }}
          />

          <Box
            sx={{
              m: 5,
              textAlign: "center",
              "& > *": { m: 1 }, // replaces actions spacing
            }}
          >
            <Button
              size="large"
              variant="contained"
              color="primary"
              component={RouterLink}
              to="/sign-up"
            >
              Sign Up
            </Button>

            <Box sx={{ m: 2 }}>
              <Typography variant="body1">
                30-day free trial then $149 US/year or $18 US/month
              </Typography>
              <Typography variant="caption">
                Get started without a credit card
              </Typography>
            </Box>

            <Box sx={{ p: 4 }}>
              <Typography variant="subtitle1">
                Need more info before signing up? Read about all{" "}
                <Link
                  href="https://seedleaf.co"
                  underline="hover"
                  target="_blank"
                  rel="noopener"
                >
                  SeedLeaf features here
                </Link>
                .
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
}
